import React, {useEffect, useRef, useState} from 'react';
import styled from 'styled-components';
import {Col, Container, Row} from "react-bootstrap";
import ReactHtmlParser from "react-html-parser";
import {Swiper, SwiperSlide} from "swiper/react";
import {Autoplay, Mousewheel, Navigation, Pagination} from "swiper";
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import {darkBlue, hover, semibold, text, white} from "../../styles/globalStyleVars";
import Title from "../Title";
import reactHtmlParser from "react-html-parser";


const TestimonialCarousel = ({data, offset}) => {


    return (
        <>
            {
                data?.list?.length > 0 &&
                <StyledTestimonial className="testimonial">

                    <Container>
                        <Row>
                            <Col md={5} className="testimonial__left">
                                <div className="border-wrapper">
                                    {data?.title && <h3 data-speed="0.8">{data?.title}</h3>}

                                    {/*<Title fontWeight={'bold'} fontSize={'24'} lineHeight={'24'}*/}
                                    {/*       text={'Some of our clients feedback'} color={'white'} textTransform={'normal'}*/}
                                    {/*/>*/}

                                </div>
                                <div className="navigation">
                                    <Container>
                                        <Row>
                                            <Col>
                                                <ul>
                                                    <li id={'testimonial-prev'}>
                                                        <svg id="Prev" xmlns="http://www.w3.org/2000/svg" width="44" height="44"
                                                             viewBox="0 0 44 44">
                                                            <g id="Rectangle_492" data-name="Rectangle 492" fill="none"
                                                               stroke="#fff"
                                                               stroke-width="1" opacity="0.5">
                                                                <rect width="44" height="44" rx="22" stroke="none"/>
                                                                <rect x="0.5" y="0.5" width="43" height="43" rx="21.5" fill="none"/>
                                                            </g>
                                                            <g id="Group_4824" data-name="Group 4824" transform="translate(17 17)">
                                                                <g id="Group_4823" data-name="Group 4823">
                                                                    <line id="Line_9" data-name="Line 9" x1="5" y2="5" fill="none"
                                                                          stroke="#fff" strokeLinecap="round" stroke-width="1"/>
                                                                    <line id="Line_10" data-name="Line 10" x2="5" y2="5"
                                                                          transform="translate(0 5)" fill="none" stroke="#fff"
                                                                          strokeLinecap="round" stroke-width="1"/>
                                                                </g>
                                                                <line id="Line_11" data-name="Line 11" x1="10"
                                                                      transform="translate(0 5)"
                                                                      fill="none" stroke="#fff" strokeLinecap="round"
                                                                      stroke-width="1"/>
                                                            </g>
                                                            <g id="Rectangle_5661" data-name="Rectangle 5661"
                                                               transform="translate(0 44) rotate(-90)" fill="none" stroke="#fff"
                                                               stroke-width="1" strokeDasharray="1 140" opacity="0">
                                                                <rect width="44" height="44" rx="22" stroke="none"/>
                                                                <rect x="0.5" y="0.5" width="43" height="43" rx="21.5" fill="none"/>
                                                            </g>
                                                        </svg>


                                                    </li>
                                                    <li id={'testimonial-next'}>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44"
                                                             viewBox="0 0 44 44">
                                                            <g id="Next" transform="translate(16429 -2014)">
                                                                <g id="Rectangle_492" data-name="Rectangle 492"
                                                                   transform="translate(-16429 2014)" fill="none" stroke="#fff"
                                                                   stroke-width="1" opacity="0.5">
                                                                    <rect width="44" height="44" rx="22" stroke="none"/>
                                                                    <rect x="0.5" y="0.5" width="43" height="43" rx="21.5"
                                                                          fill="none"/>
                                                                </g>
                                                                <g id="Group_4824" data-name="Group 4824"
                                                                   transform="translate(-17065.5 434.5)">
                                                                    <g id="Group_4823" data-name="Group 4823"
                                                                       transform="translate(11 4)">
                                                                        <line id="Line_9" data-name="Line 9" x2="5" y2="5"
                                                                              transform="translate(647.5 1592.5)" fill="none"
                                                                              stroke="#fff"
                                                                              strokeLinecap="round" stroke-width="1"/>
                                                                        <line id="Line_10" data-name="Line 10" x1="5" y2="5"
                                                                              transform="translate(647.5 1597.5)" fill="none"
                                                                              stroke="#fff"
                                                                              strokeLinecap="round" stroke-width="1"/>
                                                                    </g>
                                                                    <line id="Line_11" data-name="Line 11" x2="10"
                                                                          transform="translate(653.5 1601.5)" fill="none"
                                                                          stroke="#fff"
                                                                          strokeLinecap="round" stroke-width="1"/>
                                                                </g>
                                                                <g id="Rectangle_5661" data-name="Rectangle 5661"
                                                                   transform="translate(-16429 2058) rotate(-90)" fill="none"
                                                                   stroke="#fff"
                                                                   stroke-width="1" strokeDasharray="0" opacity="0">
                                                                    <rect width="44" height="44" rx="22" stroke="none"/>
                                                                    <rect x="0.5" y="0.5" width="43" height="43" rx="21.5"
                                                                          fill="none"/>
                                                                </g>
                                                            </g>
                                                        </svg>

                                                    </li>

                                                </ul>
                                            </Col>
                                        </Row>
                                    </Container>
                                </div>
                                {/*<div className="slider-nav">*/}
                                {/*    <NavigationIcon prev_id={'testimonial-prev'} next_id={'testimonial-next'}/>*/}

                                {/*</div>*/}
                            </Col>
                            <Col md={7} className="slider-wrap testimonial__right">
                                <div className="slider-wrap__mobile">

                                    <Title fontSize={'24'} lineHeight={'24'}
                                           text={data?.title} fontWeight={500} textTransform={'initial'}/>
                                </div>
                                {
                                    data?.list && data?.list?.length>0 ?
                                        <Swiper loop={true}
                                                slidesPerView={1}
                                                spaceBetween={30}
                                                speed='1500'
                                                autoplay
                                                slidesPerGroup={1}
                                                keyboardControl={true}
                                                modules={[Autoplay, Pagination, Navigation, Mousewheel]}
                                                navigation={{
                                                    prevEl: '#testimonial-prev',
                                                    nextEl: '#testimonial-next',
                                                }}
                                                breakpoints={{
                                                    320: {
                                                        autoplay: false,
                                                        spaceBetween: 15,

                                                    }
                                                }}>
                                            {
                                                data?.list && data?.list?.length>0 &&
                                                data?.list?.map((element,index)=>{
                                                    return(
                                                        <SwiperSlide key={index}>
                                                            <div className="slider_item">
                                                                <div className="slider_item__img">
                                                                    <div className="slider_item__img__text">
                                                                        <div className="testimonial-text">
                                                                            <svg xmlns="http://www.w3.org/2000/svg" width="46.751" height="40"
                                                                                 viewBox="0 0 46.751 40">
                                                                                <g id="Group_24416" data-name="Group 24416"
                                                                                   transform="translate(-411.174 -370.741)" opacity="0.2">
                                                                                    <path id="Path_720" data-name="Path 720"
                                                                                          d="M411.174,390.694v20.047h19.953V390.694H421.1q.374-9.6,10.023-9.93V370.741Q411.174,373.037,411.174,390.694Z"
                                                                                          transform="translate(0 0)" fill="#9cabb9"/>
                                                                                    <path id="Path_721" data-name="Path 721"
                                                                                          d="M515.432,380.765V370.741q-19.953,2.3-19.953,19.953v20.047h19.953V390.694H505.409Q505.783,381.093,515.432,380.765Z"
                                                                                          transform="translate(-57.507 0)" fill="#9cabb9"/>
                                                                                </g>
                                                                            </svg>

                                                                            {reactHtmlParser(element?.desc)}
                                                                        </div>
                                                                        <div className="testimonial-designation">
                                                                            <h3 className={'split-up'}>{element?.name}</h3>
                                                                            <p className={'split-up'}>{ReactHtmlParser(element?.designation)}</p>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                            </div>

                                                        </SwiperSlide>
                                                    )
                                                })
                                            }

                                            <SwiperSlide key={1}>
                                                <div className="slider_item">
                                                    <div className="slider_item__img">
                                                        <div className="slider_item__img__text">
                                                            <div className="testimonial-text">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="46.751" height="40"
                                                                     viewBox="0 0 46.751 40">
                                                                    <g id="Group_24416" data-name="Group 24416"
                                                                       transform="translate(-411.174 -370.741)" opacity="0.2">
                                                                        <path id="Path_720" data-name="Path 720"
                                                                              d="M411.174,390.694v20.047h19.953V390.694H421.1q.374-9.6,10.023-9.93V370.741Q411.174,373.037,411.174,390.694Z"
                                                                              transform="translate(0 0)" fill="#9cabb9"/>
                                                                        <path id="Path_721" data-name="Path 721"
                                                                              d="M515.432,380.765V370.741q-19.953,2.3-19.953,19.953v20.047h19.953V390.694H505.409Q505.783,381.093,515.432,380.765Z"
                                                                              transform="translate(-57.507 0)" fill="#9cabb9"/>
                                                                    </g>
                                                                </svg>

                                                                <p>A couple years ago, I found myself in a flight on the way to a
                                                                    country where I had not been before and that nobody I know had been,
                                                                    called Bangladesh.
                                                                    <br/><br/>
                                                                    The only thing I knew at that time, was that it was a country very
                                                                    strong in textile business, which was the reason of my visit, and
                                                                    that it was a country very different from all the ones where I had
                                                                    been to.</p>
                                                            </div>
                                                            <div className="testimonial-designation">
                                                                <h3>{'Tita Teodoro'}</h3>
                                                                <p>{ReactHtmlParser('Designation')}</p>
                                                            </div>
                                                        </div>
                                                    </div>


                                                </div>

                                            </SwiperSlide>
                                            <SwiperSlide key={2}>
                                                <div className="slider_item">
                                                    <div className="slider_item__img">
                                                        <div className="slider_item__img__text">
                                                            <div className="testimonial-text">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="46.751" height="40"
                                                                     viewBox="0 0 46.751 40">
                                                                    <g id="Group_24416" data-name="Group 24416"
                                                                       transform="translate(-411.174 -370.741)" opacity="0.2">
                                                                        <path id="Path_720" data-name="Path 720"
                                                                              d="M411.174,390.694v20.047h19.953V390.694H421.1q.374-9.6,10.023-9.93V370.741Q411.174,373.037,411.174,390.694Z"
                                                                              transform="translate(0 0)" fill="#9cabb9"/>
                                                                        <path id="Path_721" data-name="Path 721"
                                                                              d="M515.432,380.765V370.741q-19.953,2.3-19.953,19.953v20.047h19.953V390.694H505.409Q505.783,381.093,515.432,380.765Z"
                                                                              transform="translate(-57.507 0)" fill="#9cabb9"/>
                                                                    </g>
                                                                </svg>

                                                                <p>A couple years ago, I found myself in a flight on the way to a
                                                                    country where I had not been before and that nobody I know had been,
                                                                    called Bangladesh.
                                                                    <br/><br/>
                                                                    The only thing I knew at that time, was that it was a country very
                                                                    strong in textile business, which was the reason of my visit, and
                                                                    that it was a country very different from all the ones where I had
                                                                    been to.</p>
                                                            </div>
                                                            <div className="testimonial-designation">
                                                                <h3>{'Tita Teodoro'}</h3>
                                                                <p>{ReactHtmlParser('Designation')}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </SwiperSlide>
                                        </Swiper> : ''
                                }

                            </Col>
                        </Row>
                    </Container>
                </StyledTestimonial>
            }
        </>
    );
};

const StyledTestimonial = styled.section`
  padding-top: 180px;
  padding-bottom: 180px;
  position: relative;
  background: ${darkBlue};

  .swiper-button-prev, .swiper-button-next {
    display: none;
  }

  .nav-wrap {
    position: relative;
  }

  //navigation
  .navigation {
    position: absolute;
    right: ${props => props.offset ? props.offset : '90'}px;
    left: 0;
    top: calc(50% - 10vh);
    transform: translateY(-50%);
    display: inline-block;
    z-index: 1;

    ul {
      display: flex;
      margin-top: 100px !important;

      //flex-direction: column;

      li {
        cursor: pointer;

        &:first-child {
          margin-bottom: 20px;
          margin-right: 30px;
        }

        svg {
          path, #Rectangle_5661 {
            //transition: strokeDasharray 0.3s ease-in-out;
            transition: all 1s cubic-bezier(.25, .74, .22, .99);
          }
        }


        &:hover {
          svg {
            #Rectangle_5661 {
              opacity: 1;

              stroke-dasharray: 140px;
            }

            path {
              stroke: ${hover};
            }
          }
        }
      }
    }
  }

  .slider-nav {
    margin-top: 80px;
    z-index: 2;
    width: fit-content;
  }

  h2 {
    text-transform: none !important;
  }

  .testimonial__left {
    .border-wrapper {
      border-top: 1px solid rgba(156, 171, 185, 0.2);

      h3 {
        color: ${white};
      }

      display: inline-block !important;
      padding-top: 20px;
      width: auto;
      //border-top: 1px solid rgba(156, 171, 185, 0.2);
    }
  }

  .slider_item {
    position: relative;
    padding-right: 1px;

    .slider_item__img {
      position: relative;
      padding-top: calc(480 / 670 * 100%);
      overflow: hidden;

      img {
        object-fit: cover;
        display: block;
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
      }

      &__text {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
        background-color: transparent;
        padding: 65px 100px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        border: 1px solid ${white};

        .testimonial-text {
          position: relative;

          svg {
            margin-bottom: 0;
            position: absolute;
            top: -15px;
            left: -22px;
          }

          p {
            color: ${white};
          }
        }

        .testimonial-designation {
          h3 {
            font-size: 16px;
            line-height: 20px;
            font-family: ${semibold};
            color: ${white};
            margin: 0 !important;
          }

          p {
            font-size: 16px;
            line-height: 20px;
            color: ${text};
            margin: 0 !important;
          }
        }

      }
    }

    a {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      width: 100%;
      height: 100%;
      z-index: 4;
    }

  }


  .slider-wrap {
    padding-left: 0;

    &__mobile {
      display: none;
    }

    > p {
      margin-top: 20px;
      margin-bottom: 40px;
      font-size: 14px;
      font-weight: 300;
      line-height: 21px;
    }
  }

  .bottom {
    margin-top: 30px;

    h3 {
      font-size: 18px;
      font-weight: bold;
      color: inherit;
      margin: 0;
    }
  }
  @media (max-width: 1530px) {
    .slider_item {
      .slider_item__img {
        padding-top: calc(540 / 880 * 100%);
      }
    }
  }


  @media (min-width: 1660px) {
    .slider-wrap > p {
      font-size: 16px;
    }
  }

  @media (max-width: 1680px) {
    padding-top: 150px !important;
    padding-bottom: 150px !important;
    .slider-wrap {
      > p {
        font-size: 16px;
        line-height: 21px;
      }
    }

    .slider_item {
      .slider_item__img {
        padding-top: calc(480 / 670 * 100%);

        &__text {
          padding: 40px 65px;

          .testimonial-text {
            svg {
              width: 31px;
              margin-bottom: 10px;
            }


          }
        }
      }
    }
  }
  @media(max-width: 1200px){
    .slider_item {
      .slider_item__img {
        padding-top: calc(750 / 880 * 100%);
      }
    }
  }
  @media (max-width: 991px) {
    padding-top: 85px;
    padding-bottom: 85px;

    .testimonial__left {
      flex: 0 0 100%;
      max-width: 100%;
    }

    .testimonial__right {
      flex: 0 0 100%;
      max-width: 100%;
      margin-top: 40px;
    }

    .sub-title {
      padding-top: 130px;
    }

    .slider_item {
      .slider_item__img {
        padding-top: calc(450 / 670 * 100%);

        &__text {
          padding: 30px 30px;

          .testimonial-text {
            svg {
              width: 20px;
              margin-bottom: 5px;
            }
          }
        }
      }
    }
  }

  @media (max-width: 840px) {
    .sub-title {
      padding-top: 150px;
    }
  }

  @media (max-width: 768px) {
    .slider-wrap {
      padding: 0 15px !important;
    }
  }
  @media (max-width: 767px) {
    padding-top: 80px !important;
    padding-bottom: 80px !important;

    .navigation {
      ul {
        margin-bottom: 150px;
      }
    }

    .testimonial {
      &__left {
        h3 {
          margin-bottom: 40px;

        }
      }
    }

    .slider-wrap {
      padding-left: 15px !important;
      padding-right: 15px !important;
      margin-top: 0;


      .title {
        padding-right: 15px;
      }

      > p {
        //padding-left: 15px;
        padding-right: 15px;
        font-size: 14px;
        line-height: 21px;
      }

      &__mobile {
        //padding-left: 15px;
        margin-right: 15px;

        .title {
          font-size: 20px !important;
          line-height: 32px !important;
        }
      }

      .swiper-container {
        padding-right: 70px;
      }
    }

    .slider_item {
      .slider_item__img {
        padding-top: calc(423 / 324 * 100%);

        &__text {
          padding: 40px 15px;

          .testimonial-text {
            svg {
              width: 31px;
              margin-bottom: 20px;
            }
          }
        }
      }
    }

    .slider-nav {
      margin-top: 40px;
      margin-bottom: 40px;
    }

  }



`;

export default TestimonialCarousel;




